import Icon from '../Icon/Icon';

const BadgeActionLockIcon = ({className}: {className?: string}) => (
    <Icon width='40' height='40' fill='none' className={className}>
        <circle cx='20' cy='20' r='20' fill='#383E42' />
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M26.7141 28.8059H15.3665C13.6062 28.8059 12.8413 27.9437 12.8413 26.6821V17.5188L26.7141 17.5194V28.8059Z'
            stroke='#3AC9F3'
            strokeWidth='1.5'
            strokeLinejoin='round'
        />
        <path
            d='M19.7256 20.55C19.7753 20.55 19.8247 20.5526 19.873 20.5579C19.879 20.5585 19.8848 20.56 19.8906 20.5608C20.5491 20.642 21.0594 21.2026 21.0596 21.8831C21.0596 22.3186 20.8493 22.7042 20.5264 22.9475V25.385C20.5264 25.6601 20.1674 25.8831 19.7256 25.8831C19.3115 25.883 18.9706 25.6869 18.9297 25.4358L18.9258 25.385V22.9475C18.6027 22.7042 18.3926 22.3187 18.3926 21.8831C18.3927 21.2103 18.8913 20.6546 19.5391 20.5637C19.5507 20.562 19.5624 20.5603 19.5742 20.5588C19.6239 20.5532 19.6744 20.5501 19.7256 20.55Z'
            fill='#3AC9F3'
        />
        <path
            d='M14.8735 17.5187V16.1197C14.8735 13.9306 16.6481 12.156 18.8372 12.156H20.7685C22.9575 12.156 24.7321 13.9306 24.7321 16.1197V17.5187'
            stroke='#3AC9F3'
            strokeWidth='1.5'
        />
    </Icon>
);

export default BadgeActionLockIcon;
